module.exports = __webpack_public_path__ + "img/block-pet.2c0a79ee.svg";